import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tentangkami',
  templateUrl: './tentangkami.component.html',
  styleUrls: ['./tentangkami.component.scss']
})
export class TentangkamiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
